import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  todoApiSlice,
  useGetTodosQuery
} from "../../features/todoApi/todoApiSlice";

const numberOfTodos = (no_of_todos) => {
  switch (no_of_todos) {
    case 0:
      return "No task";
    case 1:
      return "1 task";
    default:
      return `${no_of_todos} tasks`;
  }
};

export default function Footer() {
  const [colorFilter, setColorFilter] = useState([]);
  const [skip, setSkip] = useState(true);

  const {
    data: filteredTodos,
    isLoading,
    isSuccess,
  } = useGetTodosQuery({ complete: false, colorFilter }, { skip });

  const { data: todos } = useGetTodosQuery({ complete: false });

  const dispatch = useDispatch();

  useEffect(() => {
    if (!isLoading && isSuccess) {
      dispatch(
        todoApiSlice.util.updateQueryData(
          "getTodos",
          { complete: false },
          () => filteredTodos
        )
      );
    }
  }, [dispatch, isLoading, isSuccess, filteredTodos, todos]);

  const handleColorFilter = (color) => {
    setSkip(false);
    if (colorFilter.includes(color)) {
      setColorFilter((prevColors) =>
        prevColors.filter((prevColor) => prevColor !== color)
      );
    } else {
      setColorFilter([...colorFilter, color]);
    }
  };

  return (
    <div className="mt-4 flex justify-between text-xs text-gray-500">
      <p>{numberOfTodos(todos?.length)} left</p>
      <ul className="flex space-x-1 items-center text-xs">
        <li
          className={`h-3 w-3 border-2 border-green-500 md:hover:bg-green-500 rounded-full cursor-pointer ${
            colorFilter.includes("green") && "bg-green-500"
          }`}
          onClick={() => handleColorFilter("green")}
        ></li>
        <li
          className={`h-3 w-3 border-2 border-red-500 md:hover:bg-red-500 rounded-full cursor-pointer ${
            colorFilter.includes("red") && "bg-red-500"
          }`}
          onClick={() => handleColorFilter("red")}
        ></li>
        <li
          className={`h-3 w-3 border-2 border-yellow-500 md:hover:bg-yellow-500 rounded-full cursor-pointer ${
            colorFilter.includes("yellow") && "bg-yellow-500"
          }`}
          onClick={() => handleColorFilter("yellow")}
        ></li>
      </ul>
    </div>
  );
}
